import script from "./HrTabPanel.vue?vue&type=script&setup=true&lang=js"
export * from "./HrTabPanel.vue?vue&type=script&setup=true&lang=js"

import "./HrTabPanel.vue?vue&type=style&index=0&id=48a7436f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-48a7436f"]])

export default __exports__
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QTabPanel});
